import React from 'react';
import PropTypes from 'prop-types';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import {pushEdapEvent} from '../../../utils/edap';

import './LastCard.less';
import './Card';

export const LastCard = ({
    aspectRatio,
    lbsId,
    text,
    searchURL,
    moduleNumber,
}) => {
    function handleOnClick() {
        const data = {
            actionlocation: `destination-properties-module-${moduleNumber}`,
            eventlbsuuid: lbsId,
            eventaction: 'card-search-click',
        };

        pushEdapEvent('search.link.click', data);
    }

    return (
        <a
            href={searchURL}
            target="_blank"
            className="LastCard"
            onClick={handleOnClick}
        >
            <AspectRatioCard {...{aspectRatio}}>
                <div
                    data-slot={'figure'}
                    className="Card__figure LastCard__figure bg-brand"
                >
                    <div className="LastCard__overlay bg-brand" />
                </div>
            </AspectRatioCard>
            <h4 className="LastCard__title">{text}</h4>
        </a>
    );
};

LastCard.propTypes = {
    aspectRatio: PropTypes.string,
};

LastCard.defaultProps = {
    aspectRatio: '4x3',
};

export default LastCard;
